enum CalendarType {
	list,
	grid4Day,
	gridWeek,
	gridMonth
}

export default CalendarType
